import { createSlice } from "@reduxjs/toolkit";

export const ViewStyleBtnCollectionSlice = createSlice({
  name: "ViewStyleBtnCollectionSlice",
  initialState: {
    boxStyleCollectionList: false,
  },
  reducers: {
    toggleActiveBoxStyle: (state) => {
      state.boxStyleCollectionList = true;
    },
    toggleActiveLineStyle: (state) => {
      state.boxStyleCollectionList = false;
    },
  },
});

export const { toggleActiveBoxStyle, toggleActiveLineStyle } =
  ViewStyleBtnCollectionSlice.actions;
export default ViewStyleBtnCollectionSlice.reducer;
